import { TOOL_GROUPS, EDUCATION, IMPACT } from "@/data/content";
import { Reveal, ChapterBadge } from "@/components/Reveal";
import { GraduationCap } from "lucide-react";

export default function ToolsImpactEducation() {
  return (
    <>
      <section id="tools" data-testid="tools-section" className="py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <ChapterBadge number="09" label="Toolkits & Tech" />
          <Reveal className="mt-8 max-w-2xl">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-charcoal-900 leading-[1.1]">
              Tools of the <em className="italic text-copper-600">trade.</em>
            </h2>
          </Reveal>

          <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {TOOL_GROUPS.map((group, i) => (
              <Reveal key={group.title} delay={Math.min(i * 0.06, 0.3)}>
                <div
                  data-testid={`tool-group-${i}`}
                  className="h-full bg-surface-white border border-charcoal-900/10 rounded-2xl p-6 hover:border-copper-600/30 transition-colors duration-300"
                >
                  <h3 className="font-mono text-[11px] tracking-[0.2em] uppercase text-copper-600">{group.title}</h3>
                  <ul className="mt-4 flex flex-col gap-2.5">
                    {group.tools.map((tool) => (
                      <li key={tool} className="flex items-center gap-2.5 text-sm text-charcoal-800">
                        <span className="w-1.5 h-1.5 rounded-full bg-copper-600/50 shrink-0" aria-hidden="true" />
                        {tool}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section data-testid="impact-section" className="py-20 sm:py-24 bg-copper-100/50 border-y border-copper-600/15">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <ChapterBadge number="10" label="Career Impact" />
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {IMPACT.map((item, i) => (
              <Reveal key={item.stat} delay={Math.min(i * 0.07, 0.3)}>
                <div data-testid={`impact-item-${i}`} className="border-l-2 border-copper-600/50 pl-5">
                  <p className="font-serif text-3xl sm:text-4xl text-charcoal-900 tracking-tight">{item.stat}</p>
                  <p className="mt-2 text-sm font-semibold text-charcoal-800">{item.title}</p>
                  <p className="mt-1.5 text-sm text-charcoal-600 leading-relaxed">{item.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section data-testid="education-section" className="py-20 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <ChapterBadge number="11" label="Education" />
          <Reveal className="mt-10">
            <div
              data-testid="education-card"
              className="max-w-2xl flex items-start gap-5 bg-surface-white border border-charcoal-900/10 rounded-2xl p-7 sm:p-8"
            >
              <span className="w-12 h-12 shrink-0 rounded-full bg-copper-100 border border-copper-600/20 flex items-center justify-center text-copper-600">
                <GraduationCap className="w-6 h-6" />
              </span>
              <div>
                <h3 className="font-serif text-2xl text-charcoal-900">{EDUCATION.degree}</h3>
                <p className="mt-2 text-sm sm:text-base text-charcoal-600">{EDUCATION.institution}</p>
                <p className="mt-1.5 font-mono text-xs tracking-[0.15em] text-charcoal-500">{EDUCATION.year}</p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
